import { ChangeDetectionStrategy, Component, EventEmitter, Output } from '@angular/core';
import { BaseModalComponent } from '../../../../core/layout/components/abstracts/base-modal.component';
import { ModalComponent } from '../../../../shared/components/modal/modal.component';
import { TranslatePipe } from '../../../../shared/pipes/trans.pipe';
import { FormControlComponent } from '../../../../shared/components/form-control/form-control.component';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-reservation-customer-name-modal',
  standalone: true,
  imports: [
    ModalComponent,
    TranslatePipe,
    FormControlComponent,
    FormsModule,
  ],
  templateUrl: './reservation-customer-name-modal.component.html',
  styleUrl: './reservation-customer-name-modal.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ReservationCustomerNameModalComponent extends BaseModalComponent<string> {

  @Output() confirm = new EventEmitter<{ customerName: string; reservationCode: string; }>();

  public customerName: string;

  public override open(val: string): void {
    this.customerName = null;
    super.open(val);
  }
}
